// extracted by mini-css-extract-plugin
module.exports = {"link":"styles__link___cFMGh","link--dark":"styles__link--dark___2xTzj"};